import { Drawer, Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import JobMap from "../helpers/JobMap/JobMap";
import { JobsDashboardTable } from "./JobsDashboardTable";
import type { Job } from "../../models";

interface Props {
	setLoading: (loading: boolean) => void;
}

const JobsDashboardWithLocalizationProvider = (props: Props) => {
	const [rightSideDrawerOpen, setRightSideDrawerOpen] = useState(false);
	const [displayedJobs, setDisplayedJobs] = useState<Job[]>([]);
	//App.tsx or AppProviders file
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					maxHeight: "100vh",
					width: "100%",
				}}
			>
				{/* border={2} */}
				<Box
					sx={{
						flexGrow: 1,
						overflow: "auto",
						transition: "margin 0.3s",
						marginRight: rightSideDrawerOpen ? "0vw" : "-40vw",
					}}
				>
					<JobsDashboardTable
						setDrawerOpenState={(open: boolean) => setRightSideDrawerOpen(open)}
						setDisplayedJobs={setDisplayedJobs}
						setLoading={props.setLoading}
						drawerOpen={rightSideDrawerOpen}
					/>
				</Box>
				{/* Right side MUI drawer */}
				<Drawer
					variant="persistent"
					anchor="right"
					open={rightSideDrawerOpen}
					onClose={() => {
						setRightSideDrawerOpen(false);
					}}
					sx={{
						flexShrink: 0,
						width: "40vw",
						"& .MuiDrawer-paper": {
							width: "40vw",
							boxSizing: "border-box",
						},
					}}
				>
					<Box
						sx={{
							p: "1rem",
							height: "100%",
							overflow: "auto",
						}}
					>
						<JobMap jobs={displayedJobs} zoomLevelToDisplayPoints={14} />
					</Box>
				</Drawer>
			</Box>
		</LocalizationProvider>
	);
};

export default JobsDashboardWithLocalizationProvider;
